import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationInfo',
    props: {
        currentPage: { type: Number, required: true },
        totalItems: { type: Number, required: true },
        itemsPerPage: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const paginationStart = computed(() => {
            return (props.currentPage - 1) * props.itemsPerPage + 1;
        });
        const paginationEnd = computed(() => {
            return Math.min(props.currentPage * props.itemsPerPage, props.totalItems);
        });
        const __returned__ = { props, paginationStart, paginationEnd };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
